module.exports = __webpack_public_path__ + "static/analytics-7d863782bbf52d2509847073b722c1d0.svg";